import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {getColumns, getFieldGridRowState, getItemId, getResultsValue} from "~/stateGetter";
import Bar from "~/components/Bar/Bar";
import get from 'lodash/get';
import cn from 'classnames';
import css from './css.css';
import {modelActionsCreator} from "~/actions/model_actions";
import {connect} from "~/redux/connect";
import ResponsiveTitle from "~/ui/ResponsiveTitle";
import { VStack, Text, renderHTML } from '~/native-ui';


export class TitleRow extends Component {
    static propTypes = {
        hasNextGroup: PropTypes.bool.isRequired,
        icon: PropTypes.string,
        iconFamily: PropTypes.string,
    };

    static defaultProps = {
        hasNextGroup: false
    };

    titlePrefix() {
        if(!this.props.toggle) { return ''; }

        return this.props.open
            ? '-'
            : '+';
    }

    getTitle = () => (
        <>
            {this.props.toggle && this.titlePrefix()}
            {this.props.title}
        </>
    )

    titleContainer() {
        let {tooltip, modelId, icon, iconFamily, description} = this.props;

        const title = <ResponsiveTitle icon={icon} iconFamily={iconFamily} modelId={modelId} tooltip={tooltip} title={this.getTitle()} />;

        if (!description) return title;

        return (
            <VStack width="100%" space="2">
                <ResponsiveTitle icon={icon} iconFamily={iconFamily} modelId={modelId} tooltip={tooltip} title={this.getTitle()} />
                <Text color="muted.500">{description && renderHTML(description)}</Text>
            </VStack>
        );
    }

    // infoGrid() {
    //     let infoCols = [];

    //     return <div className={css.infoGrid}></div>
    // }

    onBarClick = () => {
        if(!this.props.toggle) { return; }
        this.props.onChangeOpen(!this.props.open);
    }

    render() {
        let className = cn(css.titleRow, {
            [css.toggle]: this.props.toggle,
            [css.collapse]: this.props.hasNextGroup && !this.props.open
        });

        return (
            <Bar
                className={className}
                left={this.titleContainer()}
                onClick={this.onBarClick}
            >
                {/* {this.infoGrid()} */}
            </Bar>
        );
    }
}

const RXTitleRow = connect(
    (state, { modelId, row, icon, iconFamily }) => {
        return {
            ...row,
            icon, iconFamily,
            open: row.toggle ? getFieldGridRowState(state, modelId, name) : true,
            columns: getColumns(state, modelId),
            itemId: getItemId(state, modelId),
            resultValue: getResultsValue(state, modelId)
        }
    },
    (dispatch, { modelId, name }) => {
        let modelActions = modelActionsCreator(modelId);

        return {
            onChangeOpen: (open) => dispatch(modelActions.changeFieldGroupOpen(name, open))
        }
    },
    (props, dispatchProps, ownProps) => {
        let { columns, resultValue, itemId, infoColumns, ...other } = props;
        let preparedInfoColumns = [];

        if(infoColumns) {
            for(let colName of infoColumns) {
                preparedInfoColumns.push({
                    name: colName,
                    title: columns[colName],
                    value: get(resultValue.results, `${itemId}`)
                });
            }
        }

        return {
            ...ownProps, ...other, ...dispatchProps,
            infoColumns: preparedInfoColumns
        };
    }
)(TitleRow);

export default RXTitleRow;